export default __webpack_public_path__ + "static/media/how-to-integrate-meta.a5593062.png";